/* eslint-disable-next-line max-len */
export const EMAIL_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]*[a-zA-Z0-9]@[a-zA-Z0-9.-/]+\.[a-zA-Z0-9]{2,}$/;
